angular.module('inspecciones')
    .controller('damageADIFController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, infraestructurasAdminService, authenticationInfo, authenticationService) {

            $scope.authentication = authenticationInfo;
            $scope.cargandoPatologia = true;
            $scope.errorCargaPatologia = false;


            $scope.InspeccionId = $routeParams.idInspeccion;

            $scope.pestanyamenuinspeccion = 'general';

            $scope.indice = 0;

            $scope.IdDañoADIF = $routeParams.id;

            $scope.gravedadDano = null;
            $scope.gravedadDanoColor = '#9e9e9e';

            function normalizarGravedad(valor) {
                if (valor && typeof valor === 'object') {
                    valor = valor.Codigo || valor.Descripcion || valor.Nombre;
                }

                return (valor || '')
                    .toString()
                    .trim()
                    .toLowerCase()
                    .replace(/[áàäâ]/g, 'a')
                    .replace(/[éèëê]/g, 'e')
                    .replace(/[íìïî]/g, 'i')
                    .replace(/[óòöô]/g, 'o')
                    .replace(/[úùüû]/g, 'u');
            }

            function establecerGravedadDano(valor) {
                var gravedad = normalizarGravedad(valor);
                var configuracion = {
                    leve: { etiqueta: 'N1', color: '#008000' },
                    n1: { etiqueta: 'N1', color: '#008000' },
                    moderado: { etiqueta: 'N2', color: '#FFD000' },
                    n2: { etiqueta: 'N2', color: '#FFD000' },
                    severo: { etiqueta: 'N3', color: '#FF8C00' },
                    n3: { etiqueta: 'N3', color: '#FF8C00' },
                    critico: { etiqueta: 'N4', color: '#FF0000' },
                    n4: { etiqueta: 'N4', color: '#FF0000' }
                }[gravedad];

                if (!configuracion) {
                    return false;
                }

                $scope.gravedadDano = configuracion.etiqueta;
                $scope.gravedadDanoColor = configuracion.color;
                return true;
            }

            function cargarGravedadDanoDesdeInspeccion() {
                return inspeccionesService
                    .getDañosADIF($scope.InspeccionId)
                    .then(function (response) {
                        var danos = angular.isArray(response.data)
                            ? response.data
                            : [];

                        var danoEncontrado = null;

                        angular.forEach(danos, function (dano) {
                            if (
                                !danoEncontrado &&
                                String(dano.Id) ===
                                String($scope.IdDañoADIF)
                            ) {
                                danoEncontrado = dano;
                            }
                        });

                        if (danoEncontrado) {
                            establecerGravedadDano(
                                danoEncontrado.GravedadDano ||
                                danoEncontrado['GravedadDaño'] ||
                                danoEncontrado.Gravedad
                            );
                        }
                    })
                    .catch(function (error) {
                        console.warn(
                            'No se ha podido cargar la gravedad de la patología.',
                            error
                        );
                    });
            }


            //infraestructurasAdminService.getInspectores()
            //    .then(function (response) {
            //        var data = response.data;
            //        $scope.inspectores = data;

            $scope.cargandoPatologia = true;

            infraestructurasAdminService.getTiposDaño()
                .then(function (response) {
                    $scope.tipos = response.data || [];

                    return infraestructurasAdminService.getElementos();
                })
                .then(function (response) {
                    $scope.elementos = response.data || [];

                    return inspeccionesService.getCategoriasDaño();
                })
                .then(function (response) {
                    $scope.categorias = response.data || [];

                    return infraestructurasAdminService.getIntensidades();
                })
                .then(function (response) {
                    $scope.intensidades = response.data || [];

                    return inspeccionesService.getEvoluciones();
                })
                .then(function (response) {
                    $scope.evoluciones = response.data || [];

                    return inspeccionesService.getDaño(
                        $scope.IdDañoADIF
                    );
                })
                .then(function (response) {
                    var data = response.data;

                    $scope.damage = data;

                    if (!establecerGravedadDano(
                        data.GravedadDano ||
                        data['GravedadDaño'] ||
                        data.Gravedad
                    )) {
                        cargarGravedadDanoDesdeInspeccion();
                    }

                    if (!$scope.damage.Imagen) {
                        $scope.imagenSrc = null;
                        return;
                    }

                    return inspeccionesService
                        .getImagen($scope.IdDañoADIF)
                        .then(function (responseImagen) {
                            var blob = new Blob(
                                [responseImagen.data],
                                {
                                    type: responseImagen.headers(
                                        'Content-Type'
                                    )
                                }
                            );

                            $scope.imagenSrc =
                                URL.createObjectURL(blob);
                        })
                        .catch(function (errorImagen) {
                            console.warn(
                                'La patología no tiene imagen disponible',
                                $scope.IdDañoADIF,
                                errorImagen
                            );

                            // La ausencia de imagen no impide mostrar la patología.
                            $scope.imagenSrc = null;
                        });
                })
                .catch(function (error) {
                    console.error(
                        'No se han podido cargar los datos de la patología:',
                        error
                    );
                })
                .finally(function () {
                    $scope.cargandoPatologia = false;
                });


            $scope.volver = function () {

                // -----------------------------------------------------
                // SI HEMOS ENTRADO DESDE EL MODAL DE PATOLOGÍAS
                // -----------------------------------------------------

                if ($rootScope.damageDesdeModalPatologias === true) {

                    // Indicamos a infraestructurasADIF que debe
                    // volver a abrir el modal
                    $rootScope.reabrirModalPatologias = true;

                    $rootScope.damageDesdeModalPatologias = false;

                    // Volver a la pantalla anterior
                    window.history.back();

                    return;
                }


                // -----------------------------------------------------
                // COMPORTAMIENTO NORMAL:
                // volver a la inspección desde la que entramos
                // -----------------------------------------------------
                $rootScope.damageUrl = true;
                $location.path('/inspecciones/' + $scope.InspeccionId);
            }


            $scope.verHistorial = function () {
                $location.path('/inspecciones/historial/' + $scope.InspeccionId + '/' + $scope.IdDañoADIF);
            }

            $scope.verEvolucion = function () {
                $location.path('/inspecciones/evolucion/' + $scope.InspeccionId + '/' + $scope.IdDañoADIF);
            }


            $scope.guardar = function () {
                $scope.damage.CategoriaDañoId = $scope.damage.CategoriaId;
                $scope.damage.EvolucionDañoId = $scope.damage.EvolucionId;
                $scope.damage.TipoDañoId = $scope.damage.TipoId;
                $scope.damage.IntensidadDañoId = $scope.damage.IntensidadId;
                $scope.damage.PkDaño = $scope.damage.PkDano;
                //if ($scope.damage.CoordenadaX == null || $scope.damage.CoordenadaX == undefined || $scope.damage.CoordenadaX == "") {
                //    alert("El campo Coordenada X es obligatorio");
                //} else if ($scope.damage.CoordenadaY == null || $scope.damage.CoordenadaY == undefined || $scope.damage.CoordenadaY == "") {
                //    alert("El campo Coordenada X es obligatorio");
                if ($scope.damage.IntensidadDañoId == null || $scope.damage.IntensidadDañoId == undefined) {
                    alert("El campo Intensidad es obligatorio");
                } else if ($scope.damage.ElementoId == null || $scope.damage.ElementoId == undefined) {
                    alert("El campo Elemento es obligatorio");
                    //} else if ($scope.damage.InspectorId == null || $scope.damage.InspectorId == undefined) {
                    //    alert("El campo Inspector es obligatorio");
                } else if ($scope.damage.TipoId == null || $scope.damage.TipoId == undefined) {
                    alert("El campo Tipo es obligatorio");
                } else if ($scope.damage.EvolucionId == null || $scope.damage.EvolucionId == undefined) {
                    alert("El campo Evolucion es obligatorio");
                } else {
                    inspeccionesService.guardarDaño($scope.damage)
                        .then(function (response) {
                            var data = response.data;
                            $scope.damage.ElementoId = data.dañoADIF.ElementoId;
                            $scope.damage.CategoriaId = data.dañoADIF.CategoriaDaño.Id;
                            $scope.damage.EvolucionId = data.dañoADIF.EvolucionDañoId;
                            $scope.damage.TipoId = data.dañoADIF.TipoDañoId;
                            $scope.damage.IntensidadId = data.dañoADIF.IntensidadDañoId;
                            $scope.damage.PkDano = data.dañoADIF.PkDaño;
                            alert("Daño guardado correctamente")
                        });
                }
            };


            $scope.$watch('damage.PkDano', function (newVal) {
                if (newVal != null) {
                    const str = newVal.toString().padStart(4, '0');
                    $scope.damage.PkDanoFormatted = str.slice(0, 1) + '/' + str.slice(1);
                }
            });


            $scope.logout = function () {
                //$rootScope.bodylayout = "login";
                return authenticationService.logout();
            }

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
        }
    ]);
